<template>
    <div>
        <ts-page-title
            :title="$t('payRollCycleDate.pageTitle')"
            :breadcrumb="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('payRollCycleDate.pageTitle'),
                    active: true
                }
            ]"
        />
        <ts-panel>
            <ts-panel-wrapper
                class="tw-flex tw-items-center tw-justify-between"
            >
                <Button type="info" ghost @click="addNew">{{
                    $t('addNew')
                }}</Button>
                <div class="tw-justify-end tw-space-x-2">
                    <Input
                        search
                        v-model="search"
                        :placeholder="$t('search')"
                        :style="width"
                        @on-focus="() => (width = 'width: 500px')"
                        @on-blur="() => (width = 'width: 300px')"
                    />
                </div>
            </ts-panel-wrapper>
            <Table
                :columns="columns"
                :data="resources"
                size="small"
                :loading="loading"
                max-height="700"
                stripe
            >
                <template slot-scope="{ row }" slot="monthly_based">
                    <span>
                        <Icon
                            v-if="row.monthly_based"
                            type="ios-checkmark-circle-outline text-success"
                            size="20"
                        />
                        <Icon
                            v-else
                            type="ios-close-circle-outline text-danger"
                            size="20"
                        />
                    </span>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <a
                        href="#"
                        class="text-primary ml-2"
                        @click.prevent="onEdit(row)"
                        v-tooltip="$t('edit')"
                    >
                        <Icon type="ios-create" size="20" />
                    </a>
                    <Poptip
                        confirm
                        :title="$t('areYouSure')"
                        @on-ok="onDelete(row)"
                        :transfer="true"
                        :ok-text="$t('yes')"
                        :cancel-text="$t('no')"
                    >
                        <a
                            class="ml-2 text-danger"
                            v-tooltip="$t('delete')"
                            :disabled="row._deleting"
                        >
                            <i
                                class="fas fa-circle-notch fa-spin"
                                v-if="row._deleting"
                            ></i>
                            <Icon type="ios-trash" size="20" v-else />
                        </a>
                    </Poptip>
                </template>
            </Table>
            <div class="tw-flex tw-items-center tw-justify-end tw-p-4">
                <ts-i-pagination
                    v-model="pagination"
                    @navigate="fetchData"
                ></ts-i-pagination>
            </div>

            <Modal
                v-model="showForm"
                draggable
                sticky
                scrollable
                :mask="false"
                :footer-hide="true"
                :z-index="1022"
                :title="$t('payRollCycleDate.pageTitle')"
            >
                <from-action
                    ref="form_action"
                    @cancel="clearEdit"
                    @fetchData="fetchData"
                />
            </Modal>
        </ts-panel>
    </div>
</template>
<script>
import FromAction from './form.vue'
import { mapState } from 'vuex'
import { debounce } from "lodash";

export default {
    name: 'payroll-cycle-date',
    components: {
        FromAction
    },
    data () {
        return {
            loading: false,
            showForm: false,
            width: 'width: 300px'
        }
    },
    computed: {
        ...mapState('humanResource/payrollCycleDate', [
            'resources',
            'pagination'
        ]),
        search: {
            get () {
                return this.$store.state.humanResource.payrollCycleDate
                    .search
            },
            set (newValue) {
                this.$store.commit(
                    'humanResource/payrollCycleDate/SET_SEARCH',
                    newValue
                )
                this.$store.commit(
                    'humanResource/payrollCycleDate/RESET_CURRENT_PAGE'
                )
            }
        },
        columns () {
            return [
                {
                    title: this.$t('payRollCycleDate.cycleDateName'),
                    key: 'pc_date_name'
                },
                {
                    title: this.$t('payRollCycleDate.monthly'),
                    key: 'monthly_based',
                    slot: 'monthly_based'
                },
                {
                    title: this.$t('payRollCycleDate.fromday'),
                    key: 'day_from'
                },
                {
                    title: this.$t('payRollCycleDate.today'),
                    key: 'day_to'
                },
                {
                    title: this.$t('payRollCycleDate.firstCycleCalculationCay'),
                    key: 'first_cycle_calculation_day'
                },
                {
                    title: this.$t('payRollCycleDate.lateJoinBackPayDay'),
                    key: 'late_join_back_pay_day'
                },
                {
                    title: this.$t('actions'),
                    key: 'action',
                    slot: 'action',
                    align: 'center',
                    className: 'tw-space-x-2',
                    width: 90
                }
            ]
        }
    },
    methods: {
        fetchData (attributes) {
            this.loading = true
            this.$store
                .dispatch('humanResource/payrollCycleDate/fetch', attributes)
                .catch(error => {
                    this.loading = false
                    this.notice({ type: 'error', text: error.message })
                })
                .finally(() => {
                    this.loading = false
                })
        },
        addNew () {
            this.$store.commit(
                'humanResource/payrollCycleDate/SET_EDIT_DATA',
                {}
            )
            this.showForm = true
            this.$refs.form_action.setEditData()
            this.$refs.form_action.clearInput()
        },
        clearEdit () {
            this.showForm = false
            this.$refs.form_action.setEditData()
            this.$refs.form_action.clearInput()
            this.$store.commit(
                'humanResource/payrollCycleDate/SET_EDIT_DATA',
                {}
            )
        },
        async onDelete (record) {
            record._deleting = true
            this.$store
                .dispatch(
                    'humanResource/payrollCycleDate/destroy',
                    record.pc_date_id
                )
                .then(response => {
                    this.fetchData()
                    record._deleting = false
                    this.notice({
                        type: response.message_id == 0 ? 'success' : 'warning',
                        text: response.message
                    })
                })
                .catch(error => {
                    this.notice({ type: 'error', text: error.message })
                    record._deleting = false
                })
        },
        onEdit (record) {
            this.showForm = true
            this.$store.commit(
                'humanResource/payrollCycleDate/SET_EDIT_DATA',
                record
            )
            this.$refs.form_action.setEditData()
        },
        notice (not) {
            this.$Notice[not.type]({
                title: 'PAYROLLCYCLEDATE',
                desc: not.text
            })
        }
    },
    watch: {
        search: debounce(function (search) {
            this.fetchData({ search })
        }, 500)
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.fetchData()
        })
    }
}
</script>
